import { useState } from 'react';
import { Dialog } from '@m/alchemy-ui/Dialog';
import styled from 'styled-components';
import { type PageCmsPreviewProps } from '../../features';
import { CommunityPage } from '../community-page';

const StyledDialog = styled(Dialog)`
  z-index: 1050;
`;

export const PageCmsPreview = (props: PageCmsPreviewProps) => {
  const { pageSettings, mode, pageId, translations } = props;
  const pageSettingsObj = JSON.parse(pageSettings);
  const translationsObj = JSON.parse(translations);
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const closeDialog = () => setIsOpen(false);

  return (
    <div data-testid="page-cms-preview-container">
      <StyledDialog
        isOpen={isOpen}
        onClose={closeDialog}
        width={mode === 'desktop' ? '1024px' : '500px'}
        headerContent={`Custom Page ${mode} preview`}
        bodyContent={
          <CommunityPage
            pageId={pageId}
            previewMode={mode}
            previewSettings={pageSettingsObj}
            previewTranslations={translationsObj}
          />
        }
        footerButtons={[
          {
            label: 'Close',
            onClick: closeDialog,
            priority: 'primary'
          }
        ]}
      />
    </div>
  );
};
